import React, { Component } from 'react';

export default class Drilldownplaceholder extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		let { reportdata } = this.props;

		//let heightVal = $('.report-header').outerHeight()+$('.main-navbar').outerHeight()+$('.report-filtertag-container').outerHeight();

		return (
			<div>
				{
					reportdata && reportdata.length == 0 ? <div className="d-flex flex-column align-items-center justify-content-center" ref="reportsearchmessage" style={{margin: 'auto'}}>
						<img src="../images/no-search-results-placeholder.png" className="report-error-image" width="150" height="150" />

						<div className="report-error-text">No results found </div>
					</div> : null
				}
			</div>
		);
	}

}


// WEBPACK FOOTER //
// ./public/react/components/drilldownplaceholder.js